import axios from "axios";
import { Bounce, toast, Zoom } from "react-toastify";
import Cookies from "js-cookie";
import {
  API_URL_ENDPOINT,
  APP_PUBLIC_URL,
  BASE_URL,
  BUSSINESS_NAME,
} from "../appsetting";
export async function AuthCheck() {
  let refreshToken = "";
  if (getRefreshToken()) {
    refreshToken = getRefreshToken();
  }
  var headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + refreshToken,
  };

  try {
    const response = await axios.get(
      BASE_URL + API_URL_ENDPOINT.CREATE_ACCESS,
      { headers: headers }
    );

    // console.log("CreateAccess response...", response);

    if (response?.status === 200 || response?.status === true) {
      const accessToken = response?.data?.data?.accessToken;
      // console.log("Access Token:::::  ", accessToken);
      Cookies.set(BUSSINESS_NAME + "_token", accessToken);
      return accessToken;
    }
  } catch (error) {
    // Handle the error
    // console.log("AuthCheck-Error...", error.response);
    let errorStatus = JSON.parse(JSON.stringify(error?.response));
    // console.log("errorStatus",errorStatus.data);
    if (
      errorStatus?.data?.status === false &&
      errorStatus?.data?.message === "jwt expired"
    ) {
      toast.info("SESSION EXPIRED... PLEASE LOGIN");
      //store.dispatch(saveUserDetails({}));
      deleteCookies(BUSSINESS_NAME + "_token");
      deleteCookies(BUSSINESS_NAME + "_refreshToken");
      // window.location.href = process.env.PUBLIC_URL + RoutesLink?.login_route;
    }
    return errorStatus;
  }
}

export const getToken = () => {
  return Cookies.get(BUSSINESS_NAME + "_token");
};

export const getRefreshToken = () => {
  return Cookies.get(BUSSINESS_NAME + "_refreshToken");
};

export const getCookies = (name) => {
  return Cookies.get(name);
};

export const deleteCookies = (name) => {
  Cookies.remove(name, { path: APP_PUBLIC_URL });
};

export const getLoginUser = () => {
  return localStorage.getItem(BUSSINESS_NAME + "_user");
};

export const logoutUser = () => {
  deleteCookies(BUSSINESS_NAME + "_token");
  deleteCookies(BUSSINESS_NAME + "_refreshToken");
  localStorage.clear();
  window.location.href = APP_PUBLIC_URL;
};

const tostOptions = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  // transition: Bounce,
};
export const sendSuccess = (message) => {
  toast.success(message, tostOptions);
};

export const sendError = (message) => {
  toast.error(message, tostOptions);
};

export const sendWarning = (message) => {
  toast.warn(message, tostOptions);
};

export const confirmDeleteToast = (onConfirm) => {
  // Create backdrop element
  const backdrop = document.createElement("div");
  backdrop.className = "toast-backdrop";
  document.body.appendChild(backdrop);

  const handleClose = (closeToast) => {
    closeToast(); // Close the toast
    setTimeout(() => {
      if (document.body.contains(backdrop)) {
        document.body.removeChild(backdrop); // Ensure backdrop is removed after toast closes
      }
    }, 200); // Small delay to sync with toast closing animation
  };

  toast(
    ({ closeToast }) => (
      <div>
        <h6 className="text-danger">Are You Sure?</h6>
        <p>Are you sure you want to delete?</p>
        <button
          className="btn btn-danger btn-sm me-2 fw-normal"
          onClick={() => {
            onConfirm();
            handleClose(closeToast);
          }}
        >
          Yes! Delete
        </button>
        <button
          className="btn btn-primary btn-sm fw-normal"
          onClick={() => {
            handleClose(closeToast);
          }}
        >
          Cancel
        </button>
      </div>
    ),
    {
      position: "top-center",
      autoClose: false, // Keep open until user interaction
      closeOnClick: false,
      draggable: false,
      closeButton: false, // Hide default close button
    }
  );
};

export const confirmRequestToast = (
  onConfirm,
  title = null,
  message = null,
  buttontext = null
) => {
  // Create backdrop element
  const backdrop = document.createElement("div");
  backdrop.className = "toast-backdrop";
  document.body.appendChild(backdrop);

  const handleClose = (closeToast) => {
    closeToast(); // Close the toast
    setTimeout(() => {
      if (document.body.contains(backdrop)) {
        document.body.removeChild(backdrop); // Ensure backdrop is removed after toast closes
      }
    }, 200); // Small delay to sync with toast closing animation
  };

  toast(
    ({ closeToast }) => (
      <div>
        <h5 className="text-danger">{title || "Are You Sure?"}</h5>
        <p>{message || "Are you sure you want to delete?"}</p>
        <button
          className="btn btn-success btn-sm me-2 fw-normal"
          onClick={() => {
            onConfirm();
            handleClose(closeToast);
          }}
        >
          {buttontext || "Yes! Delete"}
        </button>
        <button
          className="btn btn-danger btn-sm fw-normal"
          onClick={() => {
            handleClose(closeToast);
          }}
        >
          Cancel
        </button>
      </div>
    ),
    {
      position: "top-center",
      autoClose: false, // Keep open until user interaction
      closeOnClick: false,
      draggable: false,
      closeButton: false, // Hide default close button
    }
  );
};

export const getSocialMediaName = (id) => {
  const socialMediaMap = {
    0: "Facebook",
    1: "Youtube",
    2: "Instagram",
    3: "x",
    4: "Linkedin",
  };

  return socialMediaMap[id] || "Unknown";
};

export const getImageUrl = (megaUrl) => {
  return API_URL_ENDPOINT.MegaFile + `?imageuri=${encodeURIComponent(megaUrl)}`;
};

export function formatToCustomDateTime(dateTimeString) {
  const date = new Date(dateTimeString);
  if (isNaN(date.getTime())) return "Invalid Date";

  const pad = (n) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export const status = (statusText) => {
  const normalizedText = statusText?.toLowerCase();
  let colorClass = "bg-gray-500";

  switch (normalizedText) {
    case "pendingapproval":
      colorClass = "bg-warning";
      break;
    case "openforbids":
      colorClass = "bg-info";
      break;
    case "confirmed":
      colorClass = "bg-success";
      break;
    case "enroutetopickup":
      colorClass = "bg-success";
      break;
    case "arrivedatpickup":
      colorClass = "bg-success";
      break;
    case "loadingstarted":
      colorClass = "bg-success";
      break;
    case "dispatched":
      colorClass = "bg-success";
      break;
    case "intransit":
      colorClass = "bg-success";
      break;
    case "arrivedatdestination":
      colorClass = "bg-success";
      break;
    case "unloadingstarted":
      colorClass = "bg-success";
      break;
    case "delivered":
      colorClass = "bg-success";
      break;
    case "bidreceived":
      colorClass = "bg-danger";
      break;
    case "rejected":
      colorClass = "bg-danger";
      break;
    case "cancelled":
      colorClass = "bg-danger";
      break;
    case "assigned":
      colorClass = "bg-success";
      break;
    case "notassigned":
      colorClass = "bg-gray";
      break;
    case "notuploaded":
      colorClass = "bg-warning";
      break;
    case "approved":
      colorClass = "bg-success";
      break;
    case "completed":
      colorClass = "bg-success";
      break;
    case "inprogress":
      colorClass = "bg-warning";
      break;
    case "active":
      colorClass = "bg-success";
      break;
    case "disabled":
      colorClass = "bg-danger";
      break;
    case "verified":
      colorClass = "bg-success";
      break;
    case "un-verified":
      colorClass = "bg-warning";
      break;
  }

  return (
    <span
      style={{ fontSize: 12, fontWeight: "bold" }}
      className={`text-white text-xs px-2 rounded-pill ${colorClass}`}
    >
      {addSpaceBetweenWords(statusText ?? "")}
    </span>
  );
};

export function addSpaceBetweenWords(text) {
  return text.replace(/([a-z])([A-Z])/g, "$1 $2");
}

export const gstRateMap = {
  Zero: 0, // Exempted
  Five: 5,
  Twelve: 12,
  Eighteen: 18,
  TwentyEight: 28,
};

export function validateTruckStatus(truck) {
  const now = new Date();
  const issues = [];
  if (!truck) return;
  // Helper to check expiry
  const isExpired = (date) => {
    if (!date) return true;
    return new Date(date) < now;
  };

  // Check each field
  if (!truck.insuranceExpiry || isExpired(truck.insuranceExpiry))
    issues.push("Insurance Expired or Missing");

  if (!truck.fitnessExpiry || isExpired(truck.fitnessExpiry))
    issues.push("Fitness Expired or Missing");

  if (!truck.permitExpiry || isExpired(truck.permitExpiry))
    issues.push("Permit Expired or Missing");

  if (!truck.pollutionExpiry || isExpired(truck.pollutionExpiry))
    issues.push("Pollution Expired or Missing");

  if (!truck.isActive) issues.push("KYC Missing");

  return {
    isValid: issues.length === 0,
    issues,
  };
}

export const mapStepsWithHistory = (allSteps, userHistory) => {
  if (!allSteps?.length || !userHistory?.length) return [];

  const mappedSteps = [];

  // find the last completed step in history
  const completedIndexes = userHistory
    .map(h => allSteps.findIndex(s => s.key === h.status))
    .filter(i => i !== -1);

  const lastCompletedIndex = completedIndexes.length
    ? Math.max(...completedIndexes)
    : -1;

  const lastUserStep = userHistory[userHistory.length - 1];

  for (let i = 0; i < allSteps.length; i++) {
    const step = allSteps[i];
    const userStep = userHistory.find(h => h.status === step.key);
    const dateTime = userStep?.createdAt;

    // skip step if not in history and not forced to show
    if (!userStep && step?.alwaysShow === false) continue;

    if (lastUserStep.status === "Cancelled" && step.key === lastUserStep.status) {
      mappedSteps.push({ ...step, status: "Cancelled", dateTime });
      break;
    }

    if (i < lastCompletedIndex) {
      mappedSteps.push({ ...step, status: "Completed", dateTime });
    } else if (i === lastCompletedIndex) {
      mappedSteps.push({ ...step, status: "Current", dateTime });
    } else {
      mappedSteps.push({ ...step, status: "Pending", dateTime });
    }
  }

  return mappedSteps;
};


// export const mapStepsWithHistory = (allSteps, userHistory) => {
//   if (!allSteps?.length || !userHistory?.length) return [];

//   const mappedSteps = [];
//   const lastUserStep = userHistory[userHistory.length - 1];

//   for (let i = 0; i < allSteps.length; i++) {
//     const step = allSteps[i];
//     const isInHistory = userHistory.some((h) => h.status === step.key);
//     // Only show steps that exist in user history and alwayshowtrue
//     if (!isInHistory && step?.alwaysShow == false) continue;

//     var dateTime = userHistory.find(h=>h.status == step.key)?.createdAt;

//     if (step.key !== lastUserStep.status) {
//       mappedSteps.push({ ...step, status: dateTime? "Completed" : "Pending", dateTime });
//     } else if (step.key === lastUserStep.status && lastUserStep.status == "Completed") {
//       mappedSteps.push({ ...step, status: "Completed", dateTime });
//     } else if (step.key === lastUserStep.status && lastUserStep.status == "Cancelled") {
//       mappedSteps.push({ ...step, status: "Cancelled", dateTime });
//       break;
//     } else if (step.key === lastUserStep.status) {
//       mappedSteps.push({ ...step, status: "Current", dateTime });
//     }
//   }

//   return mappedSteps;
// };
